<template>
  <div class="avatar-cropper">
    <el-upload
      ref="upload"
      :action="''"
      :show-file-list="false"
      :on-change="changeAvatar"
      :auto-upload="false"
    >
      <el-button
        size="small"
        type="primary"
        class="ch-button-blue"
      >
        選擇圖片
      </el-button>
    </el-upload>
    <div
      class="avatar-cropper-container"
      style="height: 200px; width: 300px"
    >
      <VueCropper
        ref="cropper"
        :img="file"
        :auto-crop="autoCrop"
        :auto-crop-height="autoCropHeight"
        :auto-crop-width="autoCropWidth"
        :fixed-box="fixedBox"
        :can-move-box="canMoveBox"
        :original="canScale"
        :mode="mode"
        output-type="png"
        @realTime="realTime"
      />
    </div>
    <div class="avatar-cropper-change">
      <span class="avatar-cropper-change-text">顯示調節：</span>
      <i
        class="el-icon-circle-plus"
        @click="changeScale(1)"
      />
      <i
        class="el-icon-remove"
        @click="changeScale(-1)"
      />
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
    name: 'AvatarCropper',
    computed: {
        ...mapGetters(['userInfo'])
    },
    data() {
        return {
            file: null,
            fileName: null,
            autoCrop: true, // 是否默认生成截图框
            autoCropWidth: 600, // 默认生成截图框宽度
            autoCropHeight: 400, // 默认生成截图框高度
            fixedBox: true, // 是否固定截图框大小
            mode: 'cover',
            autoScale: 1,
            canScale: false,
            canMoveBox: false
            // defaultImglist: []
        };
    },
    created() {
        // 清空默认数据
        this.file = null;
        this.fileName = null;
        // 獲取默認圖片
        // this.axios.get(this.pub.getApi().v).then(res => {
        //     if (res.data.code == 0 && res.data.result) this.defaultImglist = res.data.result.images;
        // });
    },
    methods: {
        // 選擇默認圖片
        chooseDefaultImg(data) {
            this.file = data;
            // 圖片name需要帶格式
            let imageFormat = data.match(/((\.png)|(\.jpg)|(\.jpeg))/);
            if (imageFormat) {imageFormat = imageFormat[0];}
            this.fileName = '默認圖片' + new Date().getTime() + (imageFormat || '.jpg');
        },
        beforeAvatarUpload(file) {
            return this.validateFile(file);
        },
        //验证头像格式
        validateFile(file) {
            const isJpg = file.type === 'image/jpg' || file.type === 'image/jpeg' || file.type === 'image/png';
            if (!isJpg) {
                this.$message.error('上傳圖片僅支援JPG, JPEG, PNG格式，請重新上傳！');
            }
            return isJpg;
        },
        //选择图片
        changeAvatar(file) {
            console.log(file, 'file');
            if (this.validateFile(file.raw)) {
                this.file = URL.createObjectURL(file.raw);
                let img = new Image();
                img.src = this.file;
                img.onload = () => {
                    // let size = img.naturalHeight > img.naturalWidth ? img.naturalWidth : img.naturalHeight
                    // this.autoCropHeight = size
                    // this.autoCropWidth = size
                };
                this.fileName = file.name;
            }
        },
        realTime(data) {
            if (this.file) {
                this.$refs.cropper.getCropBlob(blobData => {
                    // const file = new File([data], this.fileName, { type: data.type });
                    const file = new Blob([blobData], { type: blobData.type });
                    // this.$emit('getFileData', file)
                    this.$emit('getFileData', file, this.fileName);
                });
            }
        },
        changeScale(num) {
            num = num || 1;
            this.$refs.cropper.changeScale(num);
        }
    }
};
</script>

<style scoped lang="less">
.avatar-cropper {
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    // .cropper-crop-box{
    //     transform: scale(0.5);
    // }
    .ch-button-blue {
        border: 1px solid rgba(0, 98, 255, 1);
        border-radius: 10px;
        color: #0062ff;
        font-size: 14px;
        font-weight: 400;
        background: #ffffff;
        width: 100px;
    }
    .default-img {
        margin-top: 32px;
        img {
            cursor: pointer;
            overflow: hidden;
            border-radius: 6px;
            padding: 12px 6px;
            height: 65px;
            width: 65px;
        }
        p {
            font-size: 12px;
            text-align: center;
        }
    }
    .avatar-cropper-container {
        width: 200px;
        height: 200px;
        margin-top: 20px;
    }

    .avatar-cropper-change {
        display: flex;
        flex-direction: row;
        align-content: stretch;
        margin-top: 15px;
        line-height: initial;

        .avatar-cropper-change-text {
            font-size: 14px;
            font-weight: 400;
            color: rgba(68, 68, 79, 1);
        }

        i {
            font-size: 20px;
            cursor: pointer;
        }

        .el-icon-circle-plus {
            color: rgba(0, 98, 255, 1);
            margin-right: 11px;
        }
    }
}
</style>
